<template>
    <div>
        <div v-if="items.length > 0" style="margin-top: 10px;">
            <b-table striped hover :items="items" :small="true" :fields="fields"></b-table>
        </div>   
    </div>
</template>

<script>
    import Requestor from '@/utilities/Requestor'
    export default {
        name: "Children",
        components: {},
        props: ["viewdata"],
        data: function(){
            return {
                items: [],
                items_being_loaded: false,
                fields: ["sku", "quantity", "availability"],
            }
        },
        methods: {   
        },
        mounted: function(){
            this.items = JSON.parse(JSON.stringify(this.viewdata));
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/importables/Children.vue